import { Container, Stack, styled } from '@ethings/ui-toolkit';
import { Box } from '@mui/material';
import { FC, PropsWithChildren, ReactNode, type JSX } from 'react';

interface Props extends PropsWithChildren {
  actions: ReactNode;
  deletedBanner?: JSX.Element;
  pageSubtitle?: JSX.Element;
  'data-testid'?: string;
}

const StyledContainer = styled(Container)({
  flexGrow: 1,
  flexBasis: 0,
  overflowX: 'hidden',
  overflowY: 'auto',
});

const LayoutMobile: FC<Props> = ({ actions, children, deletedBanner, ...props }) => {
  return (
    <Box display="flex" flexDirection="column" flexWrap="wrap" sx={{ width: '100%', height: 1 }}>
      <StyledContainer id="detail-page">
        <Stack id="content" className="detail-content" display="flex" flexDirection="column" flexShrink={1} spacing={2} my={2} data-testid={props['data-testid']}>
          {deletedBanner}
          {children}
        </Stack>
      </StyledContainer>
      {actions}
    </Box>
  );
};

export default LayoutMobile;
